import { render, staticRenderFns } from "./position-list.vue?vue&type=template&id=a2cdcc1e&scoped=true";
import script from "./position-list.vue?vue&type=script&lang=jsx";
export * from "./position-list.vue?vue&type=script&lang=jsx";
import style0 from "./position-list.vue?vue&type=style&index=0&id=a2cdcc1e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "a2cdcc1e", null);
export default component.exports;